import { Locales } from '@ratehub/base-ui';

import createCreditCardDetailsStaticProps from '../functions/createCreditCardDetailsStaticProps.js';
import withFrenchLocale from '../functions/withFrenchLocale';
import CreditCardDetailsPage from '../components/CreditCardDetailsPage';


const { getStaticPaths, getStaticProps } = createCreditCardDetailsStaticProps({
    locale: Locales.FRENCH,
    fileName: 'ccDetailsSlugFR',
    path: '/cartes-de-credit/carte',
});

export default withFrenchLocale(CreditCardDetailsPage);
export { getStaticPaths, getStaticProps };

